import React from 'react';
import get from 'lodash/get';
import keys from 'lodash/keys';
import merge from 'lodash/merge';

import endpointsResource from 'src/actions/endpoints/endpointsResource';
import { useOnSave } from 'src/presentation/components/pages/chat/hooks/useOnSave';

import MobileChatEditor from './MobileChatEditor';
import WebChatEditor from './WebChatEditor';
import { chatConfigurationDefaults, newChatConfigurationDefaults } from './model/chatModel';
import { useForm } from 'src/presentation/components/forms/Form';

const formatItem = item => {
  item.configuration.onboarding.messages = item.configuration.onboarding.messages.map(message => {
    if (message.subType === 'QUICK_REPLY_REQUEST') {
      message.subTypeContent.options = message.subTypeContent.options.map(option => {
        if (option.label.length > 0) {
          option.buttonId = option.id;
        }
        return option;
      });
    }
    return message;
  });
  return item;
};

const ChatEditor = props => {
  const { item, errors, root } = props;
  const query = new URLSearchParams(window.location.search);
  const editorType = query.get('edit');
  const chatAddress = query.get('name');

  const pushNotificationAccountIds = get(props.item, 'configuration.pushNotificationAccountIds', {});

  const isMobile = keys(pushNotificationAccountIds).length > 0;
  const { add, update, validateChat } = endpointsResource.effects;
  const { resetErrors } = endpointsResource.actions;
  const isNew = !!chatAddress;
  const newChatProps = isNew && {
    address: chatAddress,
    type: 'CHAT',
    version: 1,
  };
  const initializedItem = merge(
    { isMobile },
    isNew ? newChatConfigurationDefaults : chatConfigurationDefaults,
    item,
    newChatProps
  );

  const saveHandler = useOnSave(editorType, initializedItem.isMobile);
  const formContext = useForm({
    add,
    item: formatItem(initializedItem),
    errors,
    onSave: saveHandler,
    resetErrors,
    root,
    update,
    validate: validateChat,
  });

  const handleNeedHelp = () => {
    const incomingChatVolumeUrl = 'https://help.gladly.com/docs/control-chat-volume/';
    const configuringChatUrl = 'https://help.gladly.com/docs/create-and-configure-chat';
    const url = editorType === 'throttling' ? incomingChatVolumeUrl : configuringChatUrl;
    window.open(url, 'help');
  };

  const propsWithParams = { ...props, initializedItem, editorType, formContext, handleNeedHelp };

  return isMobile ? <MobileChatEditor {...propsWithParams} /> : <WebChatEditor {...propsWithParams} />;
};

export default ChatEditor;
